/* menu-link-item.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./menu-link-item.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useMemo, useRef } from 'react';
import mergeRefs from '@atlaskit/ds-lib/merge-refs';
import { forwardRefWithGeneric } from '../../components/forward-ref-with-generic';
import { ListItem } from '../../components/list-item';
import { MenuItemBase } from './menu-item';
import { useScrollMenuItemIntoView } from './use-scroll-menu-item-into-view';
var listItemStyles = {
  root: "_10m98stt"
};
var MenuLinkItemNoRef = function MenuLinkItemNoRef(_ref, forwardedRef) {
  var testId = _ref.testId,
    actions = _ref.actions,
    children = _ref.children,
    description = _ref.description,
    elemAfter = _ref.elemAfter,
    elemBefore = _ref.elemBefore,
    href = _ref.href,
    target = _ref.target,
    actionsOnHover = _ref.actionsOnHover,
    isSelected = _ref.isSelected,
    onClick = _ref.onClick,
    interactionName = _ref.interactionName,
    isContentTooltipDisabled = _ref.isContentTooltipDisabled,
    visualContentRef = _ref.visualContentRef,
    listItemRef = _ref.listItemRef;
  var itemRef = useRef(null);
  useScrollMenuItemIntoView({
    elementRef: itemRef,
    isSelected: isSelected !== null && isSelected !== void 0 ? isSelected : false
  });
  var ref = useMemo(function () {
    return mergeRefs([itemRef, listItemRef !== null && listItemRef !== void 0 ? listItemRef : null]);
  }, [listItemRef, itemRef]);
  return /*#__PURE__*/React.createElement(ListItem, {
    ref: ref,
    xcss: listItemStyles.root
  }, /*#__PURE__*/React.createElement(MenuItemBase, {
    testId: testId,
    description: description,
    actions: actions,
    elemAfter: elemAfter
    // TODO Always use "open in new window" icon when `openInNewWindow` prop is true
    ,
    elemBefore: elemBefore,
    href: href,
    target: target,
    actionsOnHover: actionsOnHover,
    isSelected: isSelected,
    onClick: onClick,
    ref: forwardedRef,
    visualContentRef: visualContentRef,
    interactionName: interactionName,
    isContentTooltipDisabled: isContentTooltipDisabled
  }, children));
};

/**
 * __MenuLinkItem__
 *
 * A menu item link. It should be used within a `ul`.
 */
export var MenuLinkItem = forwardRefWithGeneric(MenuLinkItemNoRef);